/**
 * @generated SignedSource<<39de10e7df0b0c048676a232f7ec22dc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Shipping_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useShippingPrice_item">;
  readonly " $fragmentType": "Shipping_item";
};
export type Shipping_item$key = {
  readonly " $data"?: Shipping_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"Shipping_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "buyerId"
    },
    {
      "defaultValue": true,
      "kind": "LocalArgument",
      "name": "fetchLiveShipmentQuote"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchShippingCostInfo"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "Shipping_item",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "buyerId"
        },
        {
          "kind": "Variable",
          "name": "fetchLiveShipmentQuote",
          "variableName": "fetchLiveShipmentQuote"
        },
        {
          "kind": "Variable",
          "name": "fetchShippingCostInfo",
          "variableName": "fetchShippingCostInfo"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useShippingPrice_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "6e5220aac5db7cb838e483e215d49e71";

export default node;
